<template>
  <div class="onboarding-datatable">
    <material-card
      :title="title"
      :text="`Onboarded Accounts`"
      color="orange">
      <v-layout
        row
        wrap
        align-center>
        <v-flex md2>
          <v-select
            v-model="searchField"
            :items="searchColumns"
            :menu-props="{ maxHeight: '400' }"
            label="Select a field to Search"
            attach
            clearable
          />
        </v-flex>
        <v-flex md2>
          <v-text-field
            v-model.trim="searchInput"
            label="Search here..."
            clearable
            @click:clear="clearSearch"
            @click:append-outer="searchAll(searchInput)"
            @keyup.enter="searchAll(searchInput)"
          />
        </v-flex>
        <v-flex class="onboarding-status-filter">
          <v-checkbox
            v-model="onboardingStatusFilter"
            value="New"
            color="orange"
            label="New"
            hide-details
            class="mt-0 ml-1 onboarding-status-filter-checkbox"
          />
          <v-checkbox
            v-model="onboardingStatusFilter"
            value="In Progress"
            color="orange"
            label="In Progress"
            hide-details
            class="mt-0 ml-1 onboarding-status-filter-checkbox"
          />
          <v-checkbox
            v-model="isTrainingAccountFilter"
            value="Training Accounts"
            color="orange"
            label="Training Accounts"
            hide-details
            class="mt-0 ml-1 onboarding-status-filter-checkbox"
          />
          <Can
            I="manage"
            a="reports"
          >
            <v-btn style="background: #f5f5f5; color: black;" small @click="dispatchDownloadDataRequest" :loading="downloadingAccount"><v-icon>mdi-download</v-icon> &nbsp;Download</v-btn>
          </Can> 
        </v-flex>
      </v-layout>
      <v-progress-linear
        v-slot:progress
        v-if="loadingRequest"
        color="orange"
        indeterminate/>
      <v-data-table
        ref="accountList"
        :headers="accountHeaders"
        :items="filteredAccounts"
        class="accounts-table"
        hide-actions
        loading
        loading-text="Loading... Please wait"
        fixed-header
        item-key="Acct_ID"

      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected" @click="onRowClick">
            <!-- <td>
              <v-checkbox
                v-model="props.selected"
                color="orange"
                hide-details
              ></v-checkbox>
            </td> -->
            
            <td>
              <a v-if="$can('manage', 'onboarding')" href="#" @click="onEditAccount(props.item)">{{ props.item.Onboarding_Id }}</a>
              <span v-else>{{ props.item.Onboarding_Id }}</span> 
              <!-- <span v-if="type==='view'">{{ props.item.Onboarding_Id }}</span>
              <a
                v-else
                href="#"
                @click="onEditAccount(props.item)">{{ props.item.Onboarding_Id }}</a> -->
              
            </td>

            <td title="Onboarding Status"><helperOnboardingStatusChip :status="props.item.Onboarding_Status" /></td>
            <td title="Opportunity ID">{{ props.item.OppReg_Id }}</td>
            <!-- <td title="ACE Opportunity Number">{{ props.item.Opportunity_Number }}</td> -->
            <td title="Workload Status">{{ props.item.Workload_Status }}</td>
            <td title="Requestor">{{ props.item.Requestor_FullName }}</td>
            <td title="Date Requested">{{ props.item.Date_Requested }}</td>
            <td title="AWS Request Type">{{ props.item.AWS_Req_Type }}</td>
            <td title="Type of Request">{{ props.item.Request_Type }}</td>
            <!-- <td>{{ props.item.Engr_Assigned_To }}</td> -->
            <td title="Engineer Assigned">{{ props.item.Engineer_Name }}</td>
            <td title="Customer Name">{{ props.item.Customer_Name }}</td>
            <td title="Calculated Master Payer">{{ props.item.Calculated_Master_Payer }}</td>
            <td title="Calculated Account Name">{{ props.item.Acct_name }}</td>
            <td title="WBS">{{ props.item.WBS_code }}</td>
            <td title="IWO">{{ props.item.IWO_Code }}</td>
            <td title="AWS Credits">{{ props.item.AWS_credits }}</td>
            <td title="Account Owners">
              <span class="cropped-string-users">
                {{ getCroppedString(getEmails('Account_Owners', props.item.Account_Owners)) }}
              </span>
              <span class="full-string-users none">
                {{ getEmails('Account_Owners', props.item.Account_Owners) }}
              </span>
              <v-icon
                v-if="getEmails('Account_Owners', props.item.Account_Owners).length > 30"
                class="expand-string"
                @click="onExpandString"
                large>expand_more</v-icon>
            </td>
            <td title="IAM Users">
              <span class="cropped-string-users">
                {{ getCroppedString(getEmails('IAM_Users', props.item.IAM_Users)) }}
              </span>
              <span class="full-string-users none">
                {{ getEmails('IAM_Users', props.item.IAM_Users) }}
              </span>
              <v-icon
                v-if="getEmails('IAM_Users', props.item.IAM_Users).length > 30"
                class="expand-string"
                @click="onExpandString"
                large>expand_more</v-icon>
            </td>
            <td title="Notification">
              <span class="cropped-string-users">
                {{ getCroppedString(getEmails('Notification_List', props.item.Notification_List)) }}
              </span>
              <span class="full-string-users none">
                {{ getEmails('Notification_List', props.item.Notification_List) }}
              </span>
              <v-icon
                v-if="getEmails('Notification_List', props.item.Notification_List).length > 30"
                class="expand-string"
                @click="onExpandString"
                large>expand_more</v-icon>
            </td>
            <!-- <td>{{ getEmails('CLoudCheckr_users',props.item.CLoudCheckr_users) }}</td> -->
            <td title="Financial Owners">{{ getEmails('Financial_Owner',props.item.Financial_Owner)}}</td>
            <td title="Restricted">{{ props.item.Acct_Restricted }}</td>
            <td title="Region">{{ props.item.Specific_Region }}</td>
            <td title="Location">{{ props.item.Specific_Location }}</td>
            <td title="Account Purpose">{{ getPrimaryPurpose(props.item.Account_Purpose) }}</td>
            <td title="AwS Support Type">{{ props.item.AWS_Support_Type }}</td>
            <td title="Managed Service Type">{{ props.item.Managed_Svc }}</td>
            <td title="SaaS">{{ props.item.SaaS }}</td>
            <td title="Business Use">{{ props.item.Business_Use }}</td>
            <td title="Business Use">{{ props.item.GovCloud_Resource_Account }}</td>
          </tr>
        </template>
      </v-data-table>
      <div class="text-xs-center mt-3">
        <v-btn :disabled="!nextPaginationKey || loadingRequest" small @click="showNextData">LOAD MORE...</v-btn>
      </div>
    </material-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce } from '../../../utils/helper'

export default {
  props: ['type', 'title'],
  data () {
    return {
      searchInput: '',
      selected: [],
      onboardingStatusFilter: [],
      isTrainingAccountFilter: '',
      searchField: 'OppReg_Id',
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0
      },
      rowsPerPageItems: [5, 10, 15, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}],
      sortBy: 'Onboarding_Id',
      sortOrder: 'DESC',
      pageSize: 10,
      searchColumns: [
        {
          text: 'OppReg ID',
          value: 'OppReg_Id'
        },
        {
          text: 'Account Name',
          value: 'Acct_Name'
        },
        {
          text: 'Account DL',
          value: 'Acct_DL'
        },
        {
          text: 'Customer Name',
          value: 'Customer_Name'
        },
        {
          text: 'Master Payer ID',
          value: 'MP_ID'
        }
      ]
    }
  },
  computed: {
    ...mapState('admin/accountOnboarding', ['onboardingAccounts', 'accountHeaders', 'viewRequests', 'loadingRequest', 'nextPaginationKey','downloadingAccount']),
    filteredAccounts () {
      return this.onboardingAccounts
    }
  },
  watch: {
    onboardingStatusFilter () {
      this.$store.commit('admin/accountOnboarding/setNextPaginationKey', '')
      this.dispatchOnboardingRequest()
    },
    isTrainingAccountFilter (value) {
      console.log('filtering training accounts', this.isTrainingAccountFilter, value)
      this.$store.commit('admin/accountOnboarding/setNextPaginationKey', '')
      this.dispatchOnboardingRequest()
    },
    searchInput: debounce(function (newVal, oldVal) {
      console.log('searching', newVal, oldVal)
      this.$store.commit('admin/accountOnboarding/setNextPaginationKey', '')
      this.dispatchOnboardingRequest()
    }, 1000)
  },
  mounted () {
    this.dispatchOnboardingRequest()
  },
  beforeDestroy () {
    this.$store.commit('admin/accountOnboarding/clearViewRequestData')
  },
  methods: {
    async getFilteredAccounts () {
      this.$store.commit('admin/accountOnboarding/setNextPaginationKey', '')
      await this.dispatchDownloadDataRequest({ size: 'all' })
      return this.downloadedOnboardingAccounts
    },
    getEmails (type, data) {
      try {
        switch (type) {
          case 'Account_Owners':
            let owners = JSON.parse(data)
            return owners.map(owner => owner.email).join(', ')
          case 'IAM_Users':
          case 'Notification_List':
          case 'CLoudCheckr_users':
          case 'Financial_Owner':
            let users = JSON.parse(data)
            return users.join(', ')
          default:
            break
        }
      } catch (e) {
        return data
      }
    },
    onExpandString (e) {
      if (e.target.textContent === 'expand_more') {
        e.target.textContent = 'expand_less'
        e.target.previousSibling.classList.remove('none')
        e.target.previousSibling.previousSibling.classList.add('none')
      } else {
        e.target.textContent = 'expand_more'
        e.target.previousSibling.classList.add('none')
        e.target.previousSibling.previousSibling.classList.remove('none') 
      }
    },
    getCroppedString (emails) {
      return emails.length > 30 ? emails.substring(0, 30) + '...' : emails
    },
    getPrimaryPurpose (purposes) {
      try {
        return JSON.parse(purposes).all
      } catch (error) {
        return purposes
      }
    },
    onEditAccount (record) {
      console.log('emit update')
      this.$emit('update', record)
    },
    onRowClick (e) {
      let currentHoveredItem = document.querySelector(".current-item")
      if (currentHoveredItem) {
        currentHoveredItem.classList.remove('current-item')
      }
      e.target.closest('tr').classList.add('current-item')
    },
    buildOnboardingRequestParams (overrideParams = {}) {
      let params = {
        orderBy: this.sortBy,
        order: this.sortOrder,
        size: this.pageSize
      }

      if (this.nextPaginationKey && !('nextPaginationKey' in overrideParams)) {
        params.nextPaginationKey = this.nextPaginationKey
      }
      if (this.onboardingStatusFilter.length && !('listStatus' in overrideParams)) {
        params.listStatus = this.onboardingStatusFilter.toString()
      }
      if (this.searchInput && !('searchInput' in overrideParams)) {
        params.search = {
          [this.searchField]: this.searchInput
        }
      }
      if (this.isTrainingAccountFilter && !('isTrainingAccount' in overrideParams)) {
        params.isTrainingAccount = 'Yes'
      }

      return Object.assign(params, overrideParams)
    },
    dispatchOnboardingRequest (overrideParams = {}) {
      return this.$store.dispatch('admin/accountOnboarding/getAllOnboardingRequests', this.buildOnboardingRequestParams(overrideParams))
    },
    dispatchDownloadDataRequest (overrideParams = {}) {
      return this.$store.dispatch('admin/accountOnboarding/downloadAllOnboardingRequests', this.buildOnboardingRequestParams(overrideParams))
    },
    showNextData () {
      this.dispatchOnboardingRequest()
    },
    clearSearch () {
      this.searchInput = ''
      this.$store.commit('admin/accountOnboarding/setNextPaginationKey', '')
    },
    clearSearchColumn () {
      this.searchField = ''
      this.searchInput = ''
      this.$store.commit('admin/accountOnboarding/setNextPaginationKey', '')
    },
    searchAll (value) {
      console.log('search', value)
      this.$store.commit('admin/accountOnboarding/setNextPaginationKey', '')
      this.dispatchOnboardingRequest()
    }
  }
}
</script>
<style lang="scss" scoped>
  .cropped-string-users.none,
  .full-string-users.none{
    display: none;
  }
  .onboarding-status-filter {
    text-align: right;
  }
  .expand-string {
    font-size: 26px !important;
    line-height: 15px;
    cursor: pointer;
  }
  // tr th:first-child {
  //   position: sticky;
  //   left: 0px;
  //   line-height: 60px;
  //   z-index: 3;
  //   background: #fff;
  // }
  // tr td:first-child {
  //   position: sticky;
  //   left: 0px;
  //   line-height: 60px;
  //   z-index: 3;
  //   background: #fff;
  // }
  .onboarding-status-filter-checkbox {
    display: inline-block;
  }
</style>